export const ENTITY_TYPES = {
  CLIENT: 'clients',
  ORGANIZATION: 'organizations', 
  BRAND: 'brands'
};

export const ENTITY_HIERARCHY = {
  [ENTITY_TYPES.CLIENT]: {
    level: 1,
    parent: null,
    children: [ENTITY_TYPES.ORGANIZATION]
  },
  [ENTITY_TYPES.ORGANIZATION]: {
    level: 2,
    parent: ENTITY_TYPES.CLIENT,
    children: [ENTITY_TYPES.BRAND]
  },
  [ENTITY_TYPES.BRAND]: {
    level: 3,
    parent: ENTITY_TYPES.ORGANIZATION,
    children: []
  }
};

export const validateAssignment = (userRole, entityType, entityId, assignments) => {
  if (userRole !== 'operator') return true;

  if (!assignments || !assignments[entityType]) return false;

  return assignments[entityType].includes(entityId);
};

export const getAssignedEntities = (userAssignments, entityType) => {
  if (!userAssignments || !userAssignments[entityType]) return [];
  return userAssignments[entityType];
};

export const canAccessEntity = (userRole, userAssignments, entityType, entityId, parentEntityId = null) => {
  if (userRole === 'super_admin') return true;
  if (userRole === 'admin') return true;
  
  if (userRole === 'operator') {
    if (!userAssignments) return false;

    const directAccess = userAssignments[entityType]?.includes(entityId);
    if (directAccess) return true;

    if (parentEntityId && userAssignments[ENTITY_HIERARCHY[entityType].parent]) {
      return userAssignments[ENTITY_HIERARCHY[entityType].parent].includes(parentEntityId);
    }

    return false;
  }
  
  return false;
};

export const filterEntitiesByAccess = (entities, userRole, userAssignments, entityType) => {
  if (userRole === 'super_admin' || userRole === 'admin') {
    return entities;
  }
  
  if (userRole === 'operator') {
    if (!userAssignments || !userAssignments[entityType]) return [];

    return entities.filter(entity =>
      userAssignments[entityType].includes(entity.id)
    );
  }
  
  return [];
};